import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const todayStr = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export const api = {
  createHousehold: (name) => axios.post(`${API}/households`, { name }).then((r) => r.data),
  getHousehold: (code) => axios.get(`${API}/households/${code}`).then((r) => r.data),
  addChild: (code, body) => axios.post(`${API}/households/${code}/children`, body).then((r) => r.data),
  deleteChild: (id) => axios.delete(`${API}/children/${id}`).then((r) => r.data),
  updateChild: (id, body) => axios.patch(`${API}/children/${id}`, body).then((r) => r.data),
  getChild: (id) => axios.get(`${API}/children/${id}`).then((r) => r.data),
  setFrog: (childId, body) => axios.post(`${API}/children/${childId}/frog`, body).then((r) => r.data),
  completeLog: (logId, body) => axios.post(`${API}/logs/${logId}/complete`, body).then((r) => r.data),
  toggleTadpole: (logId, tpId) => axios.post(`${API}/logs/${logId}/tadpoles/${tpId}/toggle`).then((r) => r.data),
  newCycle: (childId) => axios.post(`${API}/children/${childId}/new-cycle`).then((r) => r.data),
  resetDay: (childId, date) => axios.post(`${API}/children/${childId}/reset`, { date }).then((r) => r.data),
  getBands: () => axios.get(`${API}/bands`).then((r) => r.data),
  pdfUrl: (band) => `${API}/pdf/${band}`,
  getTipPresets: () => axios.get(`${API}/payments/presets`).then((r) => r.data),
  createTipCheckout: (body) => axios.post(`${API}/payments/checkout`, body).then((r) => r.data),
  getPaymentStatus: (sessionId) => axios.get(`${API}/payments/status/${sessionId}`).then((r) => r.data),
};
